import { BLAdmin } from '@/types/profile.types';
import { Post } from '../helpers';

const AddExistingAdminToProject = (email: string, permissions: string[], project_uuid: string): Promise<BLAdmin> => {
  return Post({ url: `/v3/admin/auth/add-existing-admin-to-project`, body: { email, permissions, project_uuid } });
};

export default AddExistingAdminToProject;
